// import content from "containers/Enterprise/enterpriseProjects/EnterpriseApplications/EnterpriseApplicationDetails";
// import tabs from "containers/Enterprise/enterpriseProjects/EnterpriseApplications/EnterpriseApplicationDetails/tabs";
import breadcrumbs from "components/PlatformLayout/components/PlatformPageHeader/Breadcrumbs/EnterpriseApplicationBreadCrumbs";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";

const content = l(() => import("containers/Admin/EnterpriseApplications/BuildPartnerApplicationsDetails"));

// const breadCrumbs = l(() =>
//   import(
//     "components/PlatformLayout/components/PlatformPageHeader/EnterpriseApplicationBreadCrumbs"
//   ),
// );

const { ENTERPRISES_SUPER_ADMIN } = permissionTypes;

export default {
  key: "build-partner-applications-details",
  title: breadcrumbs,
  path: "/admin-enterprise/build-partner/:appId?",
  basePath: "admin-enterprise/build-partner/:appId",
  requiredParams: ["appId"],
  optionalParams: [],
  linkTarget: null,
  linkTitle: null,
  linkCategory: null,
  permission: [ENTERPRISES_SUPER_ADMIN],
  icon: null,
  tabs: null,
  content,
  sidebar: null,
};
